const REGION_OT = {
  nam: "63f23301-78ee-4c7b-a88e-1049c81be726",
};

export const ONETRUST_IDS = {
  //jp: "019428e1-30ca-76ad-8d18-c87789522a54",

  // APAC
  // kr: "0194fc2f-88c9-7ac0-b648-a637e85ef6ed",

  // EMEA
  de: "7a8e15c0-5441-43e0-902a-4c8b0f747e0b",
  eu: "3a0b10b4-f9c4-44f0-bf5c-86b32608d378",
  fr: "be8e1907-cb85-4056-8cde-04a0d0833db9",
  gb: "c2d568bd-9952-4cf2-b44d-b03920435767",
  uk: "c2d568bd-9952-4cf2-b44d-b03920435767", // fallback to GB ID

  // NAM
  es: "f405e45f-fa82-4df9-baf4-4dfbfe16fde9",
  mx: "0199ba4e-9a41-7610-b811-de6fbf992ab5",
  us: REGION_OT.nam,
  ca: REGION_OT.nam,
};
